export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/about-service-5.23b44e40-a6ef69.png";